<template>
  <div class="backcover">
    <div class="backcover__innerwrap">
      <div class="backcover__bg"></div>
      <div class="backcover__content">
        <img class="backcover__main-logo" src="static/svg/logo-white.svg">
        <div class="backcover__infobox">
          <p class="backcover__infobox-text" v-html="translations['backcoverText']"></p>
          <a class="backcover__link" :href="translations['backcoverLink'].url">{{translations['backcoverLink'].title}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PrevNextNav from '@/components/PrevNextNav';

export default {
  name: 'backcover',
  components: { PrevNextNav },
  computed: {
    ...mapGetters(['translations']),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../../scss/helpers';

.backcover {
  @include page;

  &__innerwrap {
    background: none;
  }

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: $c_primary;

    &::before {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      right: 0;
      width: 100%;
      max-width: 635px;
      height: 200px;
      background-size: 130% auto;
      background-position: center bottom;
      background-repeat: no-repeat;
      background-image: url('../../../static/svg/backcover_bg.svg');
    }

    @include landscape {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }

  &__content {
    position: absolute;
    left: 45px;
    bottom: 50px;
    color: $c_white;
    box-sizing: border-box;
    padding: 0;
    display: flex;
    align-items: flex-end;
  }

  &__main-logo {
    display: none;

    @include not-mobile {
      width: 95px;
      display: block;
      flex-shrink: 0;
      margin: 5px 0;
    }
  }

  &__infobox {
    display: block;

    @include not-mobile {
      margin-left: 25px;
      border-left: 1px solid $c_white;
      padding-left: 25px;
    }
  }

  &__infobox-text {
    @include font-block-content;
    font-size: 14px;
    margin-top: 0;
  }

  &__link {
    display: block;
    color: inherit;
    text-decoration: none;
    @include font-block-content;
    font-size: 14px;
    margin-bottom: -1px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/templates/Backcover.vue